export default {
  AllowUnlimitedChannels: 'USER_ALLOW_UNLIMITED_CHANNELS',
  DeveloperExtras: 'USER_DEVELOPER_EXTRAS',
  ChannelUserManagement: 'CHANNEL_USER_MANAGEMENT',
  AcastPlus: 'ACAST_PLUS',
  AcastAccess: 'ACAST_ACCESS',
};
